import { useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { isTextElementWrapped } from "@javascript/reactComponents/utilities/DOMUtilities";

export default function FilterItem({
  className,
  disabled = false,
  expanded = false,
  id,
  label,
  leadingContent,
  leadingContentClassName = "",
  nested = false,
  onLeadingContentClick,
  onWholeItemClick,
  selected = false,
  trailingContent,
  tooltip,
  variant,
}) {
  const leadingContentRef = useRef();
  const [isWrapped, setIsWrapped] = useState(false)

  useLayoutEffect(() => {
    if (isTextElementWrapped(leadingContentRef.current)) {
      setIsWrapped(true)
    }
  }, [])

  if (onLeadingContentClick && onWholeItemClick) {
    console.warn("Conflicting click handlers detected: onLeadingContentClick could interfere with onWholeItemClick.");
  }

  const classNames = [
    "lds-filter-item-container",
    disabled   && "disabled",
    expanded   && "expanded",
    isWrapped  && "align-start",
    nested     && "nested",
    onWholeItemClick && "cursor-pointer",
    selected   && "selected",
    variant    && `lds-filter-item-${variant}`,
    className,  // Parent class always included last
  ].filter(Boolean);

  const leadingContentClassNames = [
    "lds-filter-item-leading-content",
    leadingContentClassName,
    onLeadingContentClick && !disabled && "cursor-pointer"
  ].filter(Boolean);

  return (
    <div id={id} className={classNames.join(" ")} onClick={onWholeItemClick} title={tooltip}>
      <div className={leadingContentClassNames.join(" ")} onClick={disabled ? undefined : onLeadingContentClick}>
        {leadingContent}
        {label && <div
          ref={(ref) => {
            leadingContentRef.current = ref;
          }}
        >
          {label}
        </div>}
      </div>

      {trailingContent && <div className="lds-filter-item-trailing-content">{trailingContent}</div>}
    </div>
  );
}

FilterItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  id: PropTypes.any,
  label: PropTypes.string,
  leadingContent: PropTypes.element,
  leadingContentClassName: PropTypes.string,
  nested: PropTypes.bool,
  onLeadingContentClick: PropTypes.func,
  onWholeItemClick: PropTypes.func,
  selected: PropTypes.bool,
  tooltip: PropTypes.string,
  trailingContent: PropTypes.element,
  variant: PropTypes.oneOf([
    "brand",
    "funding",
    "milestone",
    "opinion",
    "other",
    "partnering",
    "results",
  ]),
};
